module.exports = __webpack_public_path__ + "img/info.0656bc54.svg";